export default __webpack_public_path__ + "static/media/330_dummy2016-cafe01-de.7ec595d6.png";